module.exports = __webpack_public_path__ + "img/Button-kosik-2021-10.4d2a9e46.png";